<template>
    <div>
        <el-dialog
            title="发放背景墙"
            :visible.sync="dialogBackVisible"
            :append-to-body="true"
            width="400px"
            :center="true"
            top="200px"
            :close-on-click-modal="false"
            :before-close="() => closeBackDialog()"
        >
            <el-form
                :model="BackForm"
                :rules="rules"
                ref="BackForm"
                label-width="100px"
            >
                <el-form-item label="选择背景墙" prop="back_id">
                    <el-select v-model="BackForm.back_id" placeholder="请选择背景墙" filterable clearable @change="get_img" class="back_c">
                        <el-option
                            v-for="item in back_arr"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="text-align: center;"><img :src="img" height="200px" v-if="img" style="border-radius: 10px;"></div>
            <div slot="footer">
                <el-button type="success" plain @click="submit('BackForm')" >发 放</el-button>
                <el-button plain @click="closeBackDialog()">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { UserGiveBackRequest } from '@/network/user.js'
import { ShopBackListRequest,ShopBackDetailsRequest } from '@/network/shop/ShopBack.js'

export default {
    name:'',
    data(){
        return {
            BackForm: {
                back_id: ''
            },
            rules: {
                back_id: [
                    {
                        required: true,
                        message: '请选择背景墙',
                        trigger: 'blur',
                    },
                ]
            },
            back_arr: [],
            img: ''
        }
    },
    computed:{},
    methods:{
        closeBackDialog() {
            this.BackForm = {
                back_id: ''
            }
            this.img = ''
            this.$emit('ExitBackDialog')
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                this.BackForm.user_id = this.id
                UserGiveBackRequest(this.BackForm)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$message.success('背景墙发放成功!')
                            this.$emit('refresh')
                            this.closeBackDialog()
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        },
        get_all_back() {
            ShopBackListRequest()
                .then((s) => {
                    if (s.status === 0) {
                        this.back_arr = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_img(v) {
            if(v) {
                ShopBackDetailsRequest(v)
                .then((s) => {
                    if (s.status === 0) {
                        this.img = s.result.data.picture[0]['url']
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }

            this.img = ''
        }
    },
    filters:{},
    props:{
        dialogBackVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        id: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    created(){
        this.get_all_back()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>

<style lang='less' scoped>
</style>